import { createProfile } from './states';

export const services = {
  createProfile,
};
